import { StubPage } from '../components/StubPage';

export function EmailFunnelsPage() {
  return (
    <StubPage
      title="Email funnels"
      description="Observabilité des 3 séquences Resend (newsletter bi-mensuelle, post-audit 5/21j, post-workspace 4/14j). Abonnés, open rate, bounce rate, dernier envoi, prochain prévu."
      icp="Gaetan en mode admin, pour savoir en un coup d'œil si les flux tournent et pouvoir pause / resume en cas d'incident contenu."
      status="PR 1 stub"
      tableTarget="API Resend (pas Airtable). Clé RESEND_API_KEY."
      reads={['Audiences, contacts, dernières broadcasts via API']}
      edits={['Pause / Resume séquence via POST API Resend']}
    />
  );
}
